<div class="info-item info-inq1">
  <img [src]="assets.typeInfoImg1" class="text-img eng_only" alt="Welcome" />
  <img [src]="assets.typeInfoArImg1" class="text-img ar_only" alt="Welcome" />
  <img [src]="assets.typeInfoMlImg1" class="text-img ml_only" alt="Welcome" />
</div>
<div class="info-item info-inq2">
  <img [src]="assets.typeInfoImg2" class="text-img eng_only" alt="Book and Go" />
  <img [src]="assets.typeInfoArImg2" class="text-img ar_only" alt="Book and Go" />
  <img [src]="assets.typeInfoMlImg2" class="text-img ml_only" alt="Book and Go" />
</div>
<div class="info-item info-inq3">
  <img [src]="assets.typeInfoImg3" class="text-img eng_only" alt="Best bids and Go" />
  <img [src]="assets.typeInfoArImg3" class="text-img ar_only" alt="Best bids and Go" />
  <img [src]="assets.typeInfoMlImg3" class="text-img ml_only" alt="Best bids and Go" />
</div>
